import { useState, useEffect } from 'react';
import { api } from '../utils/api';

/** Compact rewards progress bar for menu tiles. */
export default function RewardsBar({ businessId, getToken }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!businessId || !getToken) return;
    api(`/api/customers/me/rewards?businessId=${businessId}`, { getToken })
      .then((res) => (res.ok ? res.json() : null))
      .then(setData)
      .catch(() => {});
  }, [businessId, getToken]);

  if (!data) return null;
  const points = data.points ?? 0;
  const cap = data.pointsCap ?? 100;
  const pct = cap > 0 ? Math.min(100, (points / cap) * 100) : 0;

  return (
    <div className="mt-2 w-full">
      <div className="flex justify-between text-xs text-slate-500 dark:text-slate-400">
        <span>{points} / {cap} pts</span>
      </div>
      <div className="mt-0.5 h-1 rounded-full bg-slate-200 dark:bg-slate-600 overflow-hidden">
        <div
          className="h-full rounded-full bg-amber-500 transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
